import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { RISK_DISCLOSURE_POINTS } from '../mock';

export default function RiskDisclosure() {
  return (
    <section id="risk" className="relative border-t border-white/5">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-10 py-24">
        <div className="max-w-4xl mx-auto">
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 border gold-border rounded-sm flex items-center justify-center">
              <AlertTriangle size={16} className="gold-text" strokeWidth={1.6} />
            </div>
            <p className="text-[10px] tracking-[0.25em] font-mono gold-text">RISK DISCLOSURE</p>
          </div>
          <h2 className="font-display mt-6 text-3xl md:text-4xl font-bold text-white leading-[1.1]">
            Read this before subscribing.
          </h2>
          <div className="mt-10 border border-white/10 rounded-md p-8 bg-[#0c0c0e]">
            <ul className="space-y-5">
              {RISK_DISCLOSURE_POINTS.map((p, i) => (
                <li key={p} className="flex gap-4 text-sm text-zinc-300 leading-relaxed">
                  <span className="font-mono text-[11px] gold-text shrink-0 mt-1">{String(i + 1).padStart(2, '0')}</span>
                  <span>{p}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
